const Leaf = (props: any) => {
  const { attributes, children, leaf } = props;
  let renderChildren = children;

  if (leaf.bold) {
    renderChildren = <strong>{children}</strong>;
  }

  if (leaf.code) {
    renderChildren = <code>{children}</code>;
  }

  if (leaf.italic) {
    renderChildren = <em>{children}</em>;
  }

  if (leaf.underline) {
    renderChildren = <u>{children}</u>;
  }

  return (
    <span {...attributes} style={{ whiteSpace: 'pre-wrap' }}>
      {renderChildren}
    </span>
  );
};

export default Leaf;
